<template>
  <v-card elevation="6" :loading="loading" :disabled="disabled" class="mx-2">
    <v-container class="pb-0">
      <v-text-field
        label="Buscar en publicaciones"
        outlined
        append-icon="mdi-magnify"
        dense
        hide-details
        v-model="searchText"
        class="mb-2"
      ></v-text-field>
    </v-container>
    <v-card-text
      class="pa-0"
      style="overflow-y: scroll; height: calc(100vh - 156px)"
    >
      <div class="d-flex flex-wrap">
        <v-list
          three-line
          class="py-0"
          style="overflow-x: hidden; max-height: 100%; width: 100vw"
        >
          <v-list-item-group
            v-model="publicacionSeleccionada"
            active-class="blue--text"
          >
            <template v-for="(item, index) in getFilteredListaPublicaciones">
              <v-list-item :key="item._id">
                <template v-slot:default="{ active }">
                  <v-list-item-content class="">
                    <v-list-item-title class="font-weight-light text-subtitle-1"
                      >Publicación
                    </v-list-item-title>

                    <v-list-item-subtitle
                      class="text--secondary font-weight-bold text-h6"
                      >{{ item.titulo }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle class="text--disabled"
                      >Por: {{ item.usuarioUNI.nombres }}
                      {{
                        item.usuarioUNI.apellidoPaterno
                      }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-list-item>

              <v-divider
                v-if="index < getFilteredListaPublicaciones.length - 1"
                :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as debouncer from '@/utils/debounce.js'

export default {
  data() {
    return {
      loading: false,
      disabled: false,
      searchText: '',
      searchTextDebounced: ''
    }
  },

  computed: {
    ...mapGetters('user', [
      'getListaPublicaciones',
      'getPublicacionSeleccionada'
    ]),

    publicacionSeleccionada: {
      get() {
        return this.getPublicacionSeleccionada
      },

      set(value) {
        this.setPublicacionSeleccionada(value)
      }
    },

    getFilteredListaPublicaciones() {
      if (this.searchTextDebounced) {
        let key = this.searchTextDebounced.repeat(1)
        let filtered = []
        if (this.getListaPublicaciones.length) {
          filtered = this.getListaPublicaciones.filter(
            (item) =>
              item.titulo.toLowerCase().indexOf(key) !== -1 ||
              item.palabrasClave.some(
                (i) => i.toLowerCase().indexOf(key) !== -1
              )
          )
        }
        return filtered
      }
      return this.getListaPublicaciones
    }
  },

  methods: {
    ...mapActions('user', ['fetchPublicaciones']),
    ...mapMutations('user', ['setPublicacionSeleccionada'])
  },

  watch: {
    searchText: debouncer.debounce(async function (newVal) {
      this.searchTextDebounced = newVal
    }, 500)
  },

  async mounted() {
    await this.fetchPublicaciones()
  }
}
</script>

<style scoped>
.scrollPage {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(245, 245, 245, 0.15);
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(245, 245, 245, 0.15);
}

::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(245, 245, 245, 0.308);
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background-color: rgba(85, 85, 85, 0.5);
}
</style>